<template>
    <div class="revenue-warp">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">门诊日志</el-menu-item>
            <el-menu-item index="2">配方日志</el-menu-item>
            <!-- <el-menu-item index="3">优惠券</el-menu-item> -->
        </el-menu>
        <div class="content-warp">
            <outpatient v-if="activeIndex == '1'"></outpatient>
            <formula-log v-if="activeIndex == '2'"></formula-log>
            <coupon v-if="activeIndex == '3'"></coupon>
        </div>
    </div>
</template>
  
<script>
import outpatient from './component/outpatient.vue'
import formulaLog from './component/formulaLog.vue';
import coupon from './component/coupon.vue';
export default {
    // 定义引入的组件
    components: {outpatient,formulaLog,coupon },
    props: {},
    data() {
        return {
            activeIndex: '1'
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 切换tab
         */
        handleSelect(val) {
            this.activeIndex = val
        },

    },
}
</script>
<style lang="less" scoped src="./index.less"></style>